<!--
 * @Author: wsx
 * @Date: 2022-01-12 11:12:43
 * @LastEditTime: 2022-01-20 11:06:57
 * @LastEditors: your name
 * @Description:线索管理
-->
<template>
  <el-container class="clewManage">
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="deptId"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="标题" prop="clueTitle">
          <el-input
            v-model="tableParams.clueTitle"
            placeholder="标题"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="线索类型" prop="clueType">
          <h-selectcode
            type="zaxf_clue_Type"
            v-model="tableParams.clueType"
            placeholder="线索类型"
          ></h-selectcode>
        </el-form-item>
        <el-form-item label="上报人" prop="reportPersonnel">
          <el-input
            v-model="tableParams.reportPersonnel"
            placeholder="上报人"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="上报时间">
          <h-date-timerange
            v-model:end="tableParams.endDate"
            v-model:start="tableParams.startDate"
          ></h-date-timerange>
        </el-form-item>
        <el-form-item label="核实状态" prop="verifyStats">
          <h-selectcode
            type="zaxf_verify_stats"
            v-model="tableParams.verifyStats"
            bx="bx"
            placeholder="核实状态"
          ></h-selectcode>
          <!-- <el-select v-model="tableParams.verifyStats" placeholder="状态">
            <el-option label="Zone one" value="shanghai"></el-option>
            <el-option label="Zone two" value="beijing"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="userList"
          :params="tableParams"
          @handleClick="handleClick"
        >
          <template #verifyStatsDict="{ row }">
            <span>{{
              row.verifyStatsDict ? row.verifyStatsDict : "未核实"
            }}</span>
          </template>
          <template #operate="{ row }">
            <el-button @click="handleClick('info', row)">详情</el-button>
            <el-button
              v-if="row.verifyStats == null || row.verifyStats == '0'"
              @click="handleClick('sure', row)"
              >核实</el-button
            >
          </template>
        </h-table>
      </div>
    </el-card>
    <clue-user-form
      v-if="formVisible"
      v-model="formVisible"
      v-model:form="userFormData"
      v-model:modelValues="modelValues"
      :status="formStatus"
      @submit="userSubmit"
    ></clue-user-form>
  </el-container>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watch,
  ref,
  h,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { getMenutree } from "@/api/system/region.js";
import util from "@util/js";
import { getDict, dictUpdate } from "@/api/constant";
import _ from "lodash";
import clueUserForm from "./components/clueUserForm.vue";
import moment from "moment";
import { userList } from "@/api/prevention/prevention.js";
export default defineComponent({
  name: "clewManage",
  components: { clueUserForm },
  props: {},
  setup(props) {
    const state = reactive({
      dictList: [],
      parentIdD: "",
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      currentNode: {},
      importVisible: false,
      formVisible: false,
      formStatus: 1, // 1 添加  2 编辑
      userFormData: {},
      dataSource: [],
      tableData: [],
      tableSelection: [],
      tableParams: {
        clueTitle: "", //线索标题
        clueType: "", //线索类型
        endDate: new Date(),
        startDate: moment(new Date().getTime() - 24 * 3600 * 1000),
        verifyStats: "",
        reportPersonnel: "",
        // regionId: "0",
      },
      columns: [
        { type: "selection", show: false },
        {
          label: "线索标题",
          prop: "clueTitle",
        },
        {
          label: "线索类型",
          prop: "clueTypeDict",
        },
        // {
        //   label: "事发地点",
        //   prop: "cluePlace",
        // },
        {
          label: "事件描述",
          prop: "clueDescribe",
        },
        {
          label: "上报时间",
          prop: "reportTimeDict",
        },
        {
          label: "上报人",
          prop: "reportPersonnel",
        },
        {
          label: "核实状态",
          slot: "verifyStatsDict",
        },
        // {
        //   type: "operate",
        //   label: "操作",
        //   width: "100px",
        //   operates: [
        //     { name: "详情", emitKey: "info" },
        //     { name: "核实", emitKey: "sure" },
        //   ],
        // },
        {
          type: "operate",
          label: "操作",
          slot: "operate",
          width: "200px",
          operates: [{ name: "详情", emitKey: "info" }],
        },
      ],
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 组织树的筛选
    watch(
      () => state.filterText,
      (v) => {
        treeRef.value && treeRef.value.filter(v);
      }
    );

    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.regionId = item.id;
      console.log(state.tableParams);
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 递归
    const cc = (list, arr) => {
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element.deptId === Number(localStorage.getItem("userDeptId"))) {
          return arr;
        } else {
          arr.push(element.deptId);
          if (element.children.length) {
            return cc(element.children, arr) || [];
          }
        }
      }
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      // const options = { pid: "parentId", id: "deptId", rootPid: result.top };
      // const treeData = util.arrayToTree(result.deptList, options);
      state.dataSource = [result.data];
      // state.parentIdD = cc(treeData, []);
      // console.log(state.dataSource);
      // console.log(state.parentIdD);
      if (result.data) {
        currentChange(result.data);
        // nextTick(() => {
        //   state.rootNodeKey = state.currentNode.deptId;
        //   treeRef.value.setCurrentKey(state.currentNode.deptId);
        // });
      }
    };

    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    queryOrganTreAsync();
    // 点击table操作按钮
    const handleClick = (emitKey, row) => {
      if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "sure") {
        // 详情
        state.formStatus = 2; // 把表单设置核实
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
        // ElMessageBox.confirm("您正在核实此用户！", "核实", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning",
        // }).then(
        //   async () => {
        //     const res = await userVerify();
        //     if (res.code === 0) {
        //       refreshTable();
        //       ElMessage({
        //         type: "success",
        //         message: "核实成功",
        //       });
        //     }
        //   },
        //   () => {}
        // );
      }
    };

    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    const getDictAxios = async () => {
      const res = await getDict("back_up_field");
      state.dictList = res.dict;
    };
    getDictAxios();

    return {
      ...refData,
      refreshTable,
      treeRef,
      formRef,
      tableRef,
      filterNode,
      currentChange,
      handleClick,
      userList,
      resetForm,
      userSubmit,
    };
  },
});
</script>
<style lang="scss" scoped>
.clewManage {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        background-color: var(--el-color-info-lighter);
        box-sizing: border-box;
        border-color: transparent;
        border-radius: 5px;
        margin: 2px 0 2px 6px;
        text-align: center;
      }
    }
  }
}
</style>
